function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "bqo6a",
  d: "M200.146 385.376l-12.612 17.65a2.53 2.53 0 0 1-2.055 1.057c-.669 0-1.31-.267-1.783-.74l-7.567-7.564a2.522 2.522 0 0 1 3.566-3.565l5.463 5.459 10.88-15.226a2.524 2.524 0 0 1 4.108 2.93zM187.997 371.3c-6.02 0-11.793 2.39-16.049 6.648a22.688 22.688 0 0 0-6.648 16.05 22.69 22.69 0 0 0 6.648 16.049 22.689 22.689 0 0 0 16.05 6.648 22.69 22.69 0 0 0 16.049-6.648 22.689 22.689 0 0 0 6.648-16.05 22.69 22.69 0 0 0-6.648-16.049 22.688 22.688 0 0 0-16.05-6.648z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-165 -371)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#03be00",
  xlinkHref: "#bqo6a"
})));

var SvgYesGreenIcon = function SvgYesGreenIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYesGreenIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yes-green-icon.a4477fcb.svg";
export { ForwardRef as ReactComponent };